import React from 'react';
import VerifierStatus from './Components/Charts/VerifierStatus';
import linkIcon from '../Constant/Icons/link.svg';

function VerifierHome({ userDetail }) {
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                <div className='verifier-info-container'>
                    <div className="verifier-info">
                        <div className="verifier-info-item">
                            <div className="verifier-info-item-label">Staff Name:</div>
                            <div className="verifier-info-item-value">{userDetail?.NAME}</div>
                        </div>
                        <div className="verifier-info-item">
                            <div className="verifier-info-item-label">Staff ID:</div>
                            <div className="verifier-info-item-value">{userDetail?.USER_ID}</div>
                        </div>
                        <div className="verifier-info-item">
                            <div className="verifier-info-item-label">Staff Mobile:</div>
                            <div className="verifier-info-item-value">{userDetail?.MOBILE}</div>
                        </div>
                        <div className="verifier-info-item">
                            <div className="verifier-info-item-label">Staff Email:</div>
                            <div className="verifier-info-item-value">{userDetail?.EMAIL}</div>
                        </div>
                        <div >
                            <div style={{display:'flex',alignItems:'center',height:'90px'}}>
                                <img src={linkIcon} width={20} height={20} alt='link' />
                                <a className='cv-link' style={{textDecoration:'none'}} href='/CV/cv-instruction.pdf'>&ensp;CV Instruction</a>
                            </div>
                        </div>
                    </div>
                    <div className="verifier-status-container">
                        <VerifierStatus verifierData={userDetail} />
                    </div>
                </div>
                {/* <div className='chart-container'>
                    <Religion />
                </div> */}
            </div>
            <div>
                {/* <div className='chart-container'>
                    <RegistrationGraph />
                </div> */}
            </div>
        </div>
    )
}

export default VerifierHome;